import { FC } from 'react';
import { CVVInput } from 'src/app/shared/components/PaymentMethods/CVVInput';
import { getCvvJsonPath } from 'src/app/shared/components/PaymentMethods/utils/getCvvJsonPath';
import { useVgsFormForPaymentSourceId } from 'src/app/shared/components/VGSFormProvider/useVgsForm';
import { ListBookingPaymentSourcesManager } from 'obt-common';
import { margins } from '@spotnana/blocks/src/utils';
import { useFormContext } from 'rhf-v7';
import { PaymentSetupResponseStatus } from 'obt-common/types/api/v2/obt/model/payment-setup-response-status';
import { useIsCvvRequired } from '../hooks/useIsCvvRequired';
import { RetryPaymentCheckoutFormValues } from '../FormProvider/types';
import { useListBookingPaymentSourcesResponse } from '../hooks/useListBookingPaymentSourcesResponse';

export const CvvInputContainer: FC = () => {
  const { watch } = useFormContext<RetryPaymentCheckoutFormValues>();
  const paymentSourceIds = watch('selectedPaymentSourceIds');
  const listBookingPaymentSourcesResponse = useListBookingPaymentSourcesResponse();

  const selectedPaymentSourceId = paymentSourceIds[0];

  const { cvvRequirement } = useIsCvvRequired();

  const paymentSourceManager = new ListBookingPaymentSourcesManager(listBookingPaymentSourcesResponse);

  const paymentSource = paymentSourceManager.getBookingPaymentSourceById(selectedPaymentSourceId);

  const vgsFormInfo = useVgsFormForPaymentSourceId(selectedPaymentSourceId);
  const cvvJsonPath = getCvvJsonPath({
    status: cvvRequirement.status,
    fopRuleIndex: -1,
    paymentRuleIndex: -1,
  });
  const isCvvRequired = cvvRequirement.status === PaymentSetupResponseStatus.CvvRequired;
  if (!paymentSource) {
    return null;
  }

  return (
    <>
      {isCvvRequired && vgsFormInfo && (
        <div css={[margins.yb.m1point5]}>
          <CVVInput
            key={selectedPaymentSourceId}
            paymentSourceId={selectedPaymentSourceId}
            cvvRequirement={cvvRequirement}
            vgsFormInfo={vgsFormInfo}
            cvvJsonPath={cvvJsonPath}
          />
        </div>
      )}
    </>
  );
};
